/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/destructuring-assignment */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { autorun, reaction } from 'mobx';
import {
  Segment, Dimmer, Loader, Label, Icon, Pagination, Input, Modal
} from 'semantic-ui-react';
import { v4 as uuidv4 } from 'uuid';
import cx from 'classnames';
import Update from 'immutability-helper';
import { Scrollbars } from 'react-custom-scrollbars-2';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import ContentsHeaderWithResultAll from '../SubHeader/ContentsHeaderWithResultAll';
import Footer from '../Footer/Footer';
import api from '../../api';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import expandBtn from '../../images/components/content_file/expand-btn.svg';
import closeBtn from '../../images/components/content_wide_card/closeBtn.png';
import ScannedFilesInfoModal from '../Modal/ScannedFilesInfoModal';
import WithRouter from '../Extensions/WithRouter';
import RenderProjectTree from '../Extensions/RenderProjectTree';
import LicenseRow from './LicenseRow';

class LicenseDetail extends Component {
  constructor(props) {
    super(props);
    this.modalBody = null;
    this.smallBody = null;
    this.viewRef = React.createRef();
    this.licensedetail = React.createRef();
    this.state = {
      pageSize: this.props.state.user.page_limit,
      currentPage: 1,
      totalPage: '',
      viewMode: this.props.state.user.view_mode,
      licenseFileList: [],
      error: null,
      isLoading: false,
      isDetailLoading: false,
      isVisible: '',
      hasMore: false,
      activeIndex: [],
      securityTreeData: [],
      sortValue: '2',
      isSort: false,
      searchKeyword: '',
      filter: [],
      popupIndex: [],
      popupType: '',
      idReport: this.props.params.idReport,
      isOpenMSF: false,
      scannedFileIds: [],
      activePage: '',
      pdfElement: '',
      isRenderListOnly: false,
      isOpenWarnModal: false,
      totalCount: 0,
    };
  }

  componentDidMount() {
    const { state } = this.props;
    window.addEventListener('scroll', this.handleOnScroll);
    const $contentsHeader = $('.contents_header');
    const $tableHeader = $('.table_header');
    const $window = $(window);

    $window.on('scroll.contents_header', () => {
      if ($window.scrollTop() > 140) {
        $contentsHeader.addClass('fixed');
        $tableHeader.addClass('fixed');
      } else {
        $contentsHeader.removeClass('fixed');
        $tableHeader.removeClass('fixed');
      }
    });
    document.addEventListener('mousedown', this.handleClickOutside);

    this.disposeUserReaction = autorun(() => {
      this.setState({
        viewMode: state.user.view_mode,
        pageSize: state.user.page_limit,
      });
    });

    this.disposeLicenseListReaction = reaction(
      () => { return state.user.currentPrecisionLevel; },
      (currentPrecisionLevel) => {
        if (currentPrecisionLevel !== null && this.licensedetail) {
          this.getLicensefileList();
        }
      },
      {
        fireImmediately: true
      }
    );

    this.renderPopup();
    window.scrollTo(0, 0);
  }

  componentDidUpdate(prevProps) {
    const { params } = this.props;

    if (prevProps.params.idReport !== params.idReport) {
      this.setState(
        {
          idReport: params.idReport,
          licenseFileList: [],
        },
        () => {
          this.getLicensefileList();
        }
      );
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
    document.removeEventListener('mousedown', this.handleClickOutside);

    if (this.disposeUserReaction) {
      this.disposeUserReaction();
    }
    if (this.disposeLicenseListReaction) {
      this.disposeLicenseListReaction();
    }
  }

  handleActivePageChange = (e) => {
    const { totalPage, pageSize, activePage } = this.state;
    if (e.key === 'Enter') {
      if (activePage > totalPage) {
        return;
      }
      this.setState({
        licenseFileList: [],
        activeIndex: [],
        currentPage: activePage,
      }, () => {
        this.getLicensefileList(activePage, pageSize);
      });
    }
  };

  handleSearchChange = (value) => {
    this.setState({
      searchKeyword: value,
    });
  };

  handleInputActivePageChange = (e, { value }) => {
    const { totalPage } = this.state;
    if (totalPage < value) {
      return;
    }

    this.setState({
      activePage: value,
    });
  };

  handleOnScroll = () => {
    const {
      getLicensefileList,
      state: {
        error, isLoading, hasMore, viewMode
      },
    } = this;

    if (viewMode === 'list') {
      return;
    }

    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;
    if (error || isLoading || !hasMore) {
      return;
    }
    if (scrollTop + clientHeight >= scrollHeight) {
      getLicensefileList(this.state.currentPage + 1);
    }
  };

  handleChange = (value) => {
    this.setState(
      {
        searchKeyword: value,
        licenseFileList: [],
        activeIndex: [],
      },
      () => {
        this.getLicensefileList();
      }
    );
  };

  handleFilterData = (value) => {
    this.setState(
      {
        licenseFileList: [],
        activeIndex: [],
        filter: value.filter,
      },
      () => {
        this.getLicensefileList();
      }
    );
  };

  handleOtherRisk = (index, ids) => {
    const { popupIndex } = this.state;
    let newState;

    if (popupIndex.indexOf(index) === -1) {
      newState = [...popupIndex, index];
    } else {
      newState = popupIndex;
    }

    this.setState(
      {
        popupIndex: newState,
        popupType: 'type_0',
      },
      () => {
        this.getProjectTree(ids);
      }
    );
  };

  handlePopupClose = (index) => {
    const { popupIndex } = this.state;
    const newState = popupIndex.filter((i) => {
      return i !== index;
    });

    this.setState({
      popupIndex: newState,
      popupType: '',
    });
  };

  handleClickOutside = (event) => {
    const container = $('.card_detail_popup .popup_box');
    if (container && container.has(event.target).length === 0) {
      if (this.state.popupIndex.length !== 0 && this.state.popupType !== '') {
        this.setState({
          popupIndex: '',
          popupType: '',
        });
        return true;
      }
      return false;
    }
  };

  handleMSFClose = () => {
    this.setState({
      isOpenMSF: false,
    });
  };

  handlePageSizeChange = (value) => {
    this.setState(
      {
        pageSize: value,
        currentPage: 1,
        licenseFileList: [],
        activeIndex: [],
      },
      () => {
        this.getLicensefileList();
      }
    );
  };

  handlePaginationChange = (e, { activePage }) => {
    const { pageSize } = this.state;
    this.setState({
      licenseFileList: [],
      activeIndex: [],
      currentPage: activePage,
      activePage,
    }, () => {
      this.getLicensefileList(activePage, pageSize);
    });
  };

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          licenseFileList: [],
          activeIndex: [],
        },
        () => {
          this.getLicensefileList();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          licenseFileList: [],
          activeIndex: [],
        },
        () => {
          this.getLicensefileList();
        }
      );
    }
  };

  setPrecisionLevel = (value) => {
    this.setState({
      licenseFileList: [],
      activeIndex: [],
    }, () => {
      this.props.state.user.setPrecisionLevel(value);
    });
  };

  getLicensefileList = (pageNo, limit) => {
    let text;
    let filterData;
    let precisionLevel;

    const {
      isSort, sortValue, licenseFileList, pageSize, filter
    } = this.state;
    const { state, t } = this.props;
    const userStore = { ...state.user };

    const page = pageNo || 1;
    let perPage = limit || pageSize;
    if (perPage === '') {
      perPage = userStore.page_limit || localStorage.getItem('page_limit');
    }
    if (userStore.currentPrecisionLevel) {
      precisionLevel = userStore.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    if (filter.length !== 0) {
      let i = 0;
      for (i; i < filter.length; i++) {
        if (i === 0) {
          filterData = filter[i];
        } else {
          filterData = `${filterData},${filter[i]}`;
        }
      }
    } else {
      filterData = '';
    }
    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'license_name';
      } else {
        text = 'license_name_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'family_r';
      } else {
        text = 'family';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'component_count_r';
      } else {
        text = 'component_count';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'component_version_count_r';
      } else {
        text = 'component_version_count';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'scanned_file_count_r';
      } else {
        text = 'scanned_file_count';
      }
      break;
    default:
      text = 'family';
      break;
    }
    this.setState(
      {
        isLoading: true,
      },
      () => {
        api
          .getLicensefileList(
            {
              search: this.state.searchKeyword,
              filter: filterData,
              page,
              limit: perPage,
              order: text,
              precision_level: precisionLevel,
            },
            this.state.idReport
          )
          .then((response) => {
            if (this.state.licenseFileList.length !== 0 && response.pagination.current === 1) {
              return false;
            }
            const nextLicenseFileList = response.response.map((item) => {
              return {
                uploadedFileId: item.uploaded_file_id,
                licenseName: item.license_name,
                componentCount: item.component_count,
                componentVersionCount: item.component_version_count,
                licenseFamily: item.family,
                scannedFileCount: item.scanned_file_count,
              };
            });

            this.setState({
              currentPage: response.pagination.current,
              pageSize: response.pagination.per_page,
              totalPage: response.pagination.pages,
              totalCount: response.pagination.count,
              hasMore: response.pagination.next !== null,
              isLoading: false,
              licenseFileList: [...licenseFileList, ...nextLicenseFileList],
            });
          })
          .catch((err) => {
            console.log(err);
            this.setState({
              error: t('modal.error.error_load'),
              isLoading: false,
            });
          });
      }
    );
  };

  getLicenseFileDetail = (licenseName) => {
    const { t } = this.props;
    let precisionLevel;

    if (this.props.state.user.currentPrecisionLevel) {
      precisionLevel = this.props.state.user.currentPrecisionLevel;
    } else {
      precisionLevel = null;
    }

    this.setState({
      isDetailLoading: true,
      isVisible: licenseName,
    }, () => {
      api
        .getLicenseFileDetail(
          {
            license_name: licenseName,
            precision_level: precisionLevel,
          },
          this.state.idReport
        )
        .then((response) => {
          const { licenseFileList } = this.state;
          const data = response.response;
          const updatedIndex = licenseFileList.findIndex((item) => {
            return item.licenseName === licenseName;
          });
          const updatedData = Update(licenseFileList[updatedIndex], {
            licenseDetail: { $set: data },
          });
          const newData = Update(licenseFileList, {
            $splice: [[updatedIndex, 1, updatedData]],
          });
          this.setState({
            licenseFileList: newData,
            isDetailLoading: false,
            isVisible: '',
          });
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            error: t('modal.error.error_load'),
            isDetailLoading: false,
            isVisible: '',
          });
        });
    });
  };

  getProjectTree = (ufid) => {
    const { t } = this.props;
    const value = JSON.parse(`[${ufid}]`);
    const obj = {
      uploaded_file_ids: value,
    };
    api
      .getProjectTree(obj)
      .then((response) => {
        const data = response.response;
        this.setState({
          securityTreeData: data,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
        });
      });
  };

  createElementWithCanvas = () => {
    const { t } = this.props;
    //pdfElement
    const contentElem = document.querySelector('.content');
    if (contentElem) {
      const wrapper = contentElem.closest('.container');
      const clonedObject = wrapper.cloneNode(true);
      const containerEl = clonedObject.closest('.container');
      containerEl.style.paddingTop = 0;

      if (clonedObject) {
        const resultHeaderEl = clonedObject.getElementsByClassName('result_header');
        const resultHeaderInnerEl = clonedObject.getElementsByClassName('result_header_inner');
        const contentsSummaryInnerEl = clonedObject.getElementsByClassName('contents_summary_inner');
        const contentsEl = clonedObject.getElementsByClassName('contents');
        const utilWrapEl = clonedObject.getElementsByClassName('util_wrap');
        const moveTopEl = clonedObject.getElementsByClassName('move_to_top');
        const pageEle = clonedObject.getElementsByClassName('clar_pagination');
        const footerEl = clonedObject.getElementsByClassName('footer');
        const tableEl = clonedObject.getElementsByClassName('wide_card_box');
        const expandTableEl = clonedObject.getElementsByClassName('wide_card_box expand');

        if (expandTableEl.length !== 0) {
          this.modalBody = t('modal.message.clraity_report_main_warn');
          this.smallBody = t('modal.message.clarity_reporty_sub_warn');
          return this.setState({
            isOpenWarnModal: true,
          });
        }

        if (resultHeaderEl.length !== 0) {
          resultHeaderEl[0].style.top = 0;
        }

        if (resultHeaderInnerEl.length !== 0) {
          resultHeaderInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsSummaryInnerEl.length !== 0) {
          contentsSummaryInnerEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (contentsEl.length !== 0) {
          contentsEl[0].style.setProperty('padding-left', '0', 'important');
        }

        if (utilWrapEl.length !== 0) {
          while (utilWrapEl.length > 0) {
            utilWrapEl[0].parentNode.removeChild(utilWrapEl[0]);
          }
        }

        if (moveTopEl.length !== 0) {
          while (moveTopEl.length > 0) {
            moveTopEl[0].parentNode.removeChild(moveTopEl[0]);
          }
        }

        if (pageEle.length !== 0) {
          while (pageEle.length > 0) {
            pageEle[0].parentNode.removeChild(pageEle[0]);
          }
        }

        if (footerEl.length !== 0) {
          while (footerEl.length > 0) {
            footerEl[0].parentNode.removeChild(footerEl[0]);
          }
        }

        //wide_card_box wide_card_type_01
        if (tableEl.length > 15) {
          let i = 0;
          for (i; i < tableEl.length; i++) {
            if ((i === 14 && tableEl.length > 15) || (i > 15 && (i - 14) % 18 === 0)) {
              tableEl[i].classList.add('page-break');
            }
          }
        }
      }

      document.body.appendChild(clonedObject);

      this.setState({
        pdfElement: clonedObject,
        isRenderListOnly: true,
      });
    }
  };

  generatePdfCallback = () => {
    const { pdfElement } = this.state;

    document.body.removeChild(pdfElement);
    this.setState({
      pdfElement: '',
      isRenderListOnly: false,
    });
  };

  toggleRow = (index, litigatorCode) => {
    const { activeIndex } = this.state;
    let newState;

    if (activeIndex.indexOf(index) > -1) {
      newState = activeIndex.filter((i) => {
        return i !== index;
      });
    } else {
      this.getLicenseFileDetail(litigatorCode);
      newState = [...activeIndex, index];
    }
    this.setState({ activeIndex: newState });
  };

  toggleViewMode = (value) => {
    this.setState({
      viewMode: value,
      currentPage: 1,
      searchKeyword: '',
      licenseFileList: [],
      activeIndex: [],
    }, () => {
      this.getLicensefileList();
    });
  };

  clearValue = (tagValue) => {
    const { filter } = this.state;
    let newState;
    if (filter.indexOf(tagValue) > -1) {
      newState = filter.filter((el) => {
        return el !== tagValue;
      });
    } else {
      newState = [];
    }
    this.setState(
      {
        licenseFileList: [],
        activeIndex: [],
        filter: newState,
      },
      () => {
        this.getLicensefileList();
      }
    );
  };

  clearAllValue = () => {
    this.setState(
      {
        licenseFileList: [],
        activeIndex: [],
        filter: [],
      },
      () => {
        this.getLicensefileList();
      }
    );
  };

  closeModal = () => {
    this.modalBody = null;
    this.smallBody = null;
    this.setState({
      isOpenWarnModal: false,
    });
  };

  clearSearch = () => {
    this.setState(
      {
        searchKeyword: '',
        licenseFileList: [],
        activeIndex: [],
      },
      () => {
        this.getLicensefileList();
      }
    );
  };

  renderValue = () => {
    const { filter } = this.state;
    const { t } = this.props;

    const licenseFilter = filter.filter((item) => {
      return item.indexOf('license') > -1;
    });

    const filterObj = { license: licenseFilter, };

    return (
      <div>
        {filterObj.license.length !== 0 && (
          <Label.Group>
            <span>
              <strong>License</strong>
            </span>
            {filterObj.license.map((item) => {
              return (
                <Label as="a" key={uuidv4()}>
                  {item.indexOf('_pt') > -1 && 'Protective'}
                  {item.indexOf('_pm') > -1 && 'Permissive'}
                  {item.indexOf('_o') > -1 && 'Others'}
                  <Icon
                    name="close"
                    onClick={() => {
                      return this.clearValue(item.toString());
                    }}
                  />
                </Label>
              );
            })}
          </Label.Group>
        )}

        {filter.length !== 0 ? (
          <div
            className="clear_all"
            onClick={() => {
              return this.clearAllValue();
            }}
          >
            {t('project.menu.clear_all_filters')}
          </div>
        ) : null}
      </div>
    );
  };

  renderPopup = () => {
    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tac', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });

    $(document).on('mouseover', '.wide_card_wrap .wide_card_table .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
    $(document).on('mouseover', '.card_detail_popup .table_type_1 .tal', function () {
      const $this = $(this);
      if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
        $this.attr('title', $this.text());
      }
    });
  };

  render() {
    const {
      error,
      hasMore,
      isLoading,
      licenseFileList,
      activeIndex,
      securityTreeData,
      sortValue,
      isSort,
      filter,
      popupIndex,
      popupType,
      isDetailLoading,
      isVisible,
      viewMode,
      pageSize,
      currentPage,
      totalPage,
      activePage,
      pdfElement,
      searchKeyword,
      totalCount,
    } = this.state;

    const {
      state, location, params, t, navigate
    } = this.props;

    return (
      <div
        ref={this.licensedetail}
        className="result_file"
      >
        <ContentsHeaderWithResultAll
          onChangeSearch={this.handleChange}
          onSubmit={this.handleFilterData}
          clearSearch={this.clearSearch}
          filter={filter}
          idReport={this.props.params.idReport}
          totalCount={totalCount}
          handlePrecisionLevel={this.setPrecisionLevel}
          viewMode={viewMode}
          pageSize={pageSize}
          handlePageSizeChange={this.handlePageSizeChange}
          toggleViewMode={this.toggleViewMode}
          refElement={pdfElement}
          currentPage={currentPage}
          isRenderListOnly={this.state.isRenderListOnly}
          createElementWithCanvas={this.createElementWithCanvas}
          generatePdfCallback={this.generatePdfCallback}
          handleSearchChange={this.handleSearchChange}
          location={location}
          state={state}
          params={params}
          translate={t}
          navigate={navigate}
          searchKeyword={searchKeyword}
        />
        <div className="content">
          {filter.length !== 0 ? <div className="tag_list">{this.renderValue()}</div> : ''}
          <div className="content_projects_List">
            <div className="wide_card_wrap">
              <div className="table_header">
                <div className="table_header_inner">
                  <table className="wide_card_table wide_card_scope">
                    <colgroup>
                      <col style={{ width: '3.9%', maxWidth: '36px' }} />
                      <col style={{ width: '13%', maxWidth: '120px' }} />
                      <col style={{ width: '9.1%', maxWidth: '84px' }} />
                      <col style={{ width: '23.2%' }} />
                      <col style={{ width: '23.2%' }} />
                      <col style={{ width: '23.2%' }} />
                      <col style={{ width: '4.3%', maxWidth: '40px' }} />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th className="checkbox_wrap tal">
                          <div className="checkbox" />
                        </th>
                        <th className="tal">
                          <a className="sorting_button" data-id="1" onClick={this.onChangeSorting}>
                            {t('list.title.license_name')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="2" onClick={this.onChangeSorting}>
                            {t('list.title.family')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="3" onClick={this.onChangeSorting}>
                            {t('list.title.component')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="4" onClick={this.onChangeSorting}>
                            {t('list.title.component_version_ellipsis')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th className="tac">
                          <a className="sorting_button" data-id="5" onClick={this.onChangeSorting}>
                            {t('list.title.scanned_file')}
                            {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : ''}
                            {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : ''}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {licenseFileList.map((item, index) => {
                return (
                  <div
                    className={cx(
                      'wide_card_box',
                      {
                        expand: activeIndex.indexOf(index) >= 0,
                      },
                      {
                        card_detail_popup_show: popupIndex.indexOf(index) >= 0,
                      },
                      {
                        type_0: popupType === 'type_0',
                      }
                    )}
                    key={item.licenseName.toString()}
                  >
                    <table className="wide_card_table wide_card_item">
                      <colgroup>
                        <col style={{ width: '3.9%', maxWidth: '36px' }} />
                        <col style={{ width: '13%', maxWidth: '120px' }} />
                        <col style={{ width: '9.1%', maxWidth: '84px' }} />
                        <col style={{ width: '61.5%' }} />
                        <col style={{ width: '4.3%', maxWidth: '40px' }} />
                      </colgroup>
                      <tbody>
                        <tr
                          className="sum_line"
                          onClick={() => {
                            return this.toggleRow(index, item.licenseName);
                          }}
                        >
                          <td className="checkbox_wrap border-none tal">
                            <div className="checkbox" />
                          </td>
                          <td
                            className="border-none tal"
                            style={{
                              maxWidth: '120px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            <strong>{item.licenseName}</strong>
                          </td>
                          <td className="border-none tac">{item.licenseFamily}</td>
                          <td className="tal sum_td" colSpan="3">
                            <table className="wide_card_table wide_card_item">
                              <colgroup>
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                                <col style={{ width: '33%' }} />
                              </colgroup>
                              <tbody>
                                <tr>
                                  <td className="tac">{item.componentCount}</td>
                                  <td className="tac">{item.componentVersionCount}</td>
                                  <td className="tac">{item.scannedFileCount}</td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                          <td className="border-none tac">
                            <a
                              className="expand_button"
                            >
                              <img src={expandBtn} alt="" />
                            </a>
                          </td>
                        </tr>
                        {
                          isDetailLoading && isVisible === item.licenseName ? (
                            <tr>
                              <td className="border-none" colSpan="6">
                                <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
                                  <Loader active={isDetailLoading && isVisible === item.licenseName} inline="centered" />
                                </div>
                              </td>
                            </tr>
                          ) : (
                            <tr className="extend_item">
                              <td className="checkbox_wrap border-none tal">&nbsp;</td>
                              <td className="border-none tal">&nbsp;</td>
                              <td className="border-none tac">&nbsp;</td>
                              <td className="tal border-none sum_td" colSpan="3">
                                {
                                  item.licenseDetail
                                  && (
                                    <LicenseRow
                                      childRef={this.viewRef}
                                      rowData={item.licenseDetail}
                                      uid={item.uploadedFileId}
                                      t={t}
                                      state={state}
                                      location={location}
                                      params={params}
                                    />
                                  )
                                }
                              </td>
                            </tr>
                          )
                        }
                      </tbody>
                    </table>
                    {item.licenseDetail ? (
                      <div className="wide_card_detail">
                        <div className="wide_card_detail_top type_description">
                          <p className="description">{t('list.title.family_detail')}</p>
                          <p className="version_text">{item.licenseDetail.license_family}</p>
                        </div>
                        <div className="wide_card_detail_bottom">
                          <a
                            className={cx('card_detail_popup_show', {
                              active: popupIndex.indexOf(index) >= 0 && popupType === 'type_0',
                            })}
                            style={{ cursor: 'pointer' }}
                            onClick={() => {
                              return this.handleOtherRisk(
                                index,
                                item.licenseDetail.uploaded_file_ids
                              );
                            }}
                          >
                            {t('list.title.other_file_license')}
                          </a>
                        </div>
                      </div>
                    ) : null}
                    {securityTreeData.length !== 0 && popupType === 'type_0' && (
                      <div className="card_detail_popup card_detail_popup_1">
                        <div className="popup_box">
                          <h3 className="popup_header">
                            <a
                              className="card_detail_popup_hide"
                              style={{ cursor: 'pointer' }}
                              onClick={() => {
                                return this.handlePopupClose(index);
                              }}
                            >
                              <img src={closeBtn} alt="" />
                            </a>
                          </h3>
                          <div className="popup_content">
                            <Scrollbars
                              renderTrackHorizontal={() => {
                                return <div />;
                              }}
                              renderThumbHorizontal={() => {
                                return <div />;
                              }}
                            >
                              <RenderProjectTree
                                treeData={securityTreeData}
                                translate={t}
                                tableType={false}
                                state={state}
                              />
                            </Scrollbars>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
              {error && <div className="error_log">{error}</div>}
              {isLoading && (
                <Segment>
                  <Dimmer active inverted>
                    <Loader size="medium" style={{ lineHeight: '15px' }}>Loading</Loader>
                  </Dimmer>
                </Segment>
              )}
              {
                viewMode === 'list' && licenseFileList.length !== 0
                && (
                  <div className="clar_pagination" style={{ marginTop: '10px', textAlign: 'center' }}>
                    <Pagination
                      activePage={currentPage}
                      totalPages={totalPage}
                      onPageChange={this.handlePaginationChange}
                      //size="mini"
                      ellipsisItem={{ content: <Icon name="ellipsis horizontal" />, icon: true }}
                      firstItem={currentPage !== 1 ? { content: <Icon name="angle double left" />, icon: true } : null}
                      lastItem={currentPage !== totalPage ? { content: <Icon name="angle double right" />, icon: true } : null}
                      prevItem={currentPage > 1 ? { content: <Icon name="angle left" />, icon: true } : null}
                      nextItem={currentPage < totalPage ? { content: <Icon name="angle right" />, icon: true } : null}
                    />
                    <div className="active_page">
                      <Input
                        type="number"
                        label={t('list.title.active_page')}
                        min={1}
                        value={activePage}
                        onChange={this.handleInputActivePageChange}
                        onKeyPress={this.handleActivePageChange}
                      />
                    </div>
                  </div>
                )
              }
              {!hasMore && <Footer />}
            </div>
          </div>
        </div>
        <ScannedFilesInfoModal
          isOpenMSF={this.state.isOpenMSF}
          closeModal={this.handleMSFClose}
          ufid={this.state.idReport}
          scannedFileIds={this.state.scannedFileIds}
          translate={t}
        />
        <Modal open={this.state.isOpenWarnModal} onClose={this.closeModal}>
          <div className="modal_popup_wrap">
            <div className="modal_popup_box">
              <div className="modal_popup">
                <h2 className="title">{t('modal.title.attention')}</h2>
                <p className="text">{this.modalBody}</p>
                {
                  this.smallBody
                  && <p className="small_text">{this.smallBody}</p>
                }
                <div className="button_wrap">
                  <a
                    className="center_button"
                    onClick={this.closeModal}
                    style={{ cursor: 'pointer' }}
                  >
                    {t('modal.button.ok')}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LicenseDetail))));
